/**
 * CommunityRail — horizontally scrollable section of community cards,
 * reused for Trending / Popular / Recommended / Recently Active.
 */

import React from 'react';
import { motion } from 'framer-motion';
import { fadeUp, stagger } from '@/lib/motion';
import CommunityCard from './CommunityCard';

export default function CommunityRail({ eyebrow, title, communities, getReason }) {
  if (!communities.length) return null;

  return (
    <section className="u-container mt-14 md:mt-16">
      <p className="u-eyebrow mb-3"><span className="inline-block h-1.5 w-1.5 rounded-full bg-coral" /> {eyebrow}</p>
      <h2 className="font-display text-2xl font-semibold tracking-tight text-ink sm:text-3xl">{title}</h2>

      <motion.div
        variants={stagger} initial="hidden" animate="show"
        className="scrollbar-none -mx-6 mt-6 flex snap-x gap-4 overflow-x-auto px-6 pb-2 md:mx-0 md:grid md:grid-cols-3 md:gap-5 md:overflow-visible md:px-0 lg:grid-cols-4"
      >
        {communities.map((c, i) => (
          <motion.div key={c.id} variants={fadeUp} custom={i} className="w-64 shrink-0 snap-start md:w-auto">
            <CommunityCard community={c} reason={getReason?.(c)} />
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}
